function ds(sorgu) {
    const p = new URLSearchParams();
    for (const [k, v] of Object.entries(sorgu)) {
        if (v !== undefined && v !== '')
            p.set(k, String(v));
    }
    const s = p.toString();
    return s ? `?${s}` : '';
}
export async function odemeleriListele(istemci, sorgu = {}) {
    return istemci.istek(`/odemeler${ds(sorgu)}`);
}
export async function iadeleriListele(istemci, sorgu = {}) {
    return istemci.istek(`/iadeler${ds(sorgu)}`);
}
//# sourceMappingURL=odemeler.js.map